var rmUtil = require("../rmlibrary_old/util");
var PDFPage = require("./page");
var PDFPageTemplate = require("./page-template");
function PDFSection(children, attributes, compress) {
    PDFPage.apply(this, arguments);
    this.templateId = attributes.template;
}
rmUtil.inherits(PDFSection, PDFPage);
PDFSection.prototype.getBlock = function (pdf) {
    var templateNode = this.templateId ? PDFPageTemplate.getById(this.templateId) : null;
    var template, pageFormat, pageOrientation, pageWidth, pageHeight;
    var skipFirst = false;
    if (templateNode) {
        pageFormat = templateNode.size || "letter";
        pageOrientation = templateNode.orientation || "portrait";
        if (templateNode.width && templateNode.height) {
            pageFormat = [templateNode.width, templateNode.height];
        }
    }
    else {
        pageFormat = "letter";
        pageOrientation = "portrait";
        pageWidth = null;
        pageHeight = null;
    }
    this.size = pageFormat;
    this.orientation = pageOrientation;
    this.width = pageWidth;
    this.height = pageHeight;
    if (!pdf) {
        pdf = this.getPDF();
        skipFirst = true;
    }
    if (templateNode)
        template = templateNode.generate(pdf);
    else
        template = pdf.block({}, []);
    var contents = pdf.block({ ref: this.children[0] && this.children[0].originalNode.parentElement }, this.children.map(function (child) {
        return child.generate(pdf);
    }));
    var section = pdf.section({ format: pageFormat, orientation: pageOrientation, compress: this.compress }, template, contents);
    section.pdf = pdf;
    section.skipFirst = skipFirst;
    return section;
};
PDFSection.prototype.getNumberOfPages = function () {
    var section = this.getBlock();
    return section.getNumberOfPages(section.pdf.doc);
};
PDFSection.prototype.generate = function (pdf) {
    var section = this.getBlock(pdf);
    section.draw(section.pdf.doc, section.skipFirst);
    return section.pdf;
};
module.exports = PDFSection;
//# sourceMappingURL=module.js.map